(() => {
  const root = window.TN?.root || '/';
  const money = n => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(n / 100);
  const escape = s => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const dialog = document.querySelector('#tn-cart');
  const menu = document.querySelector('#tn-mobile-menu');
  const menuTrigger = document.querySelector('[data-menu-open]');
  const syncScrollLock = () => document.documentElement.classList.toggle('tn-modal-open', !!document.querySelector('dialog[open]'));
  menuTrigger?.addEventListener('click', () => {
    menu.showModal();
    menuTrigger.setAttribute('aria-expanded', 'true');
    syncScrollLock();
  });
  menu?.querySelector('[data-menu-close]').addEventListener('click', () => menu.close());
  menu?.addEventListener('click', e => {
    if(e.target === menu) {
      const rect = menu.getBoundingClientRect();
      if(e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) menu.close();
    }
    if(e.target.closest('a')) menu.close();
  });
  menu?.addEventListener('close', () => {
    menuTrigger.setAttribute('aria-expanded', 'false');
    syncScrollLock();
  });
  matchMedia('(min-width: 1025px)').addEventListener('change', e => { if(e.matches && menu?.open) menu.close(); });
  let timer, busy = false;
  const toast = text => { const box = document.querySelector('.tn-toast'); box.textContent = text; box.classList.add('is-visible'); clearTimeout(timer); timer = setTimeout(() => box.classList.remove('is-visible'), 4000); };
  async function api(path, body) {
    const response = await fetch(root + path, body ? { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(body) } : {});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'İşlem tamamlanamadı. Lütfen yeniden deneyin.');
    return data;
  }
  function cartSuggestions(cart) {
    const pool = [...document.querySelectorAll('template[data-cart-suggestion]')];
    const inCart = new Set(cart.items.map(item => String(item.product_id || item.id)));
    const candidates = pool.filter(el => !inCart.has(el.dataset.productId) && !cart.items.some(item => String(item.variant_id || item.id) === el.dataset.variantId));
    const selected = candidates.slice(0,2);
    if (!selected.length) return '';
    return `<aside class="tn-cart-suggestions"><h3>Seçtiklerinize uygun eşlikçiler</h3><p>Sepetinizdeki ürünlerle birlikte kullanabileceğiniz lezzetler.</p>${selected.map(el => el.innerHTML).join('')}</aside>`;
  }
  async function updateCartRecommendations(cart) {
    if (!cart.items.length || !document.querySelector('[data-cart-recommendations]')) return [];
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4000);
    try {
      const response = await fetch(`${root}?section_id=tn-cart-recommendations`, {headers:{Accept:'text/html'},signal:controller.signal});
      if (!response.ok) return [];
      const fragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const templates = fragment.querySelectorAll('template[data-cart-suggestion]');
      return Array.from(templates, node => document.importNode(node, true));
    } catch (_) { return []; }
    finally { clearTimeout(timeout); }
  }
  let cartRenderVersion = 0, latestCart = null;
  function discountForm(cart) {
    const codes = (cart.discount_codes || []).filter(item => item.applicable);
    return `<div class="tn-cart-discount"><form data-cart-discount><label><span>İndirim kodu</span><input name="discount" type="text" autocomplete="off" autocapitalize="characters" spellcheck="false" maxlength="100" placeholder="Kodunuzu girin" required></label><button type="submit" class="tn-button">Uygula</button></form><p class="tn-cart-discount-message" data-discount-message role="status" aria-live="polite"></p>${codes.length ? `<ul class="tn-cart-discount-codes">${codes.map(item => `<li><span>${escape(item.code)}</span><button type="button" data-cart-code-remove="${escape(item.code)}" aria-label="${escape(item.code)} kodunu kaldır">×</button></li>`).join('')}</ul>` : ''}<small>Yeni kod, mevcut indirim kodunun yerini alır. İndirimler uygun ürünlere uygulanır.</small></div>`;
  }
  async function applyCartDiscount(code, removing = false) {
    if (busy) return;
    const previous = (latestCart?.discount_codes || []).filter(item => item.applicable).map(item => item.code);
    const next = removing ? previous.filter(item => item.toLowerCase() !== code.toLowerCase()).join(',') : code;
    busy = true;
    const controls = [...document.querySelectorAll('[data-cart-discount] input,[data-cart-discount] button,[data-cart-code-remove],.tn-cart-summary button[name="checkout"]')];
    controls.forEach(button => button.disabled = true);
    document.querySelectorAll('[data-discount-message]').forEach(node => node.textContent = 'İndirim kontrol ediliyor…');
    try {
      let cart = await api('cart/update.js', { discount: next });
      const accepted = removing || (cart.discount_codes || []).some(item => item.applicable && item.code.toLowerCase() === code.toLowerCase());
      if (!accepted) cart = await api('cart/update.js', { discount: previous.join(',') });
      await paint(cart);
      document.querySelectorAll('[data-discount-message]').forEach(node => {
        node.textContent = accepted ? (removing ? 'İndirim kodu kaldırıldı.' : 'İndirim uygulandı. Güncel tutarı aşağıda görebilirsiniz.') : 'Bu kod geçerli değil veya sepetinizde uygun ürün bulunmuyor. Kodu ve ürünleri kontrol edin.';
        node.classList.toggle('is-error', !accepted);
      });
    } catch (error) { report(error); }
    finally { busy = false; controls.forEach(button => button.disabled = false); }
  }
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-cart-discount]');
    if (!form) return;
    event.preventDefault();
    const code = form.elements.discount.value.trim();
    if (!code) return;
    applyCartDiscount(code);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cart-code-remove]');
    if (button) applyCartDiscount(button.dataset.cartCodeRemove, true);
  });
  async function paint(cart, focusControl) {
    const version = ++cartRenderVersion;
    const recommendations = await updateCartRecommendations(cart);
    if (version !== cartRenderVersion) return;
    latestCart = cart;
    document.querySelector('[data-cart-recommendations]')?.replaceChildren(...recommendations);
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const title = document.querySelector('#tn-cart-title');
    title.innerHTML = `Sepetim <span class="tn-cart-line-count">${cart.item_count} ürün</span>`;
    const html = cart.items.length ? `<div class="tn-cart-lines">${cart.items.map(item => `<article class="tn-cart-item"><a href="${escape(item.url)}">${item.image ? `<img src="${escape(item.image)}" alt="${escape(item.product_title)}" width="95" height="117">` : ''}</a><div><h3><a href="${escape(item.url)}">${escape(item.product_title)}</a></h3>${window.TNMarketing?.cartLine(item, money, escape) || `<p>${money(item.final_line_price)}</p>`}<div class="tn-cart-item-actions"><div class="tn-quantity" role="group" aria-label="${escape(item.product_title)} adedi"><button data-cart-key="${escape(item.key)}" data-cart-action="decrease" data-cart-quantity="${item.quantity - 1}" ${item.quantity === 1 ? 'disabled' : ''} aria-label="${escape(item.product_title)} adedini azalt">−</button><span>${item.quantity}</span><button data-cart-key="${escape(item.key)}" data-cart-action="increase" data-cart-quantity="${item.quantity + 1}" aria-label="${escape(item.product_title)} adedini artır">+</button></div><button class="tn-remove" data-cart-key="${escape(item.key)}" data-cart-action="remove" data-cart-quantity="0">Kaldır</button></div></div></article>`).join('')}${window.TN.preview || (cart.discount_codes || []).some(item => item.applicable) ? '' : document.querySelector('#tn-cart-offer-template')?.innerHTML || ''}${cartSuggestions(cart)}</div><div class="tn-cart-summary">${window.TN.preview ? '' : discountForm(cart)}${window.TNMarketing?.cartSavings(cart, money) || ''}<div class="tn-cart-total" aria-live="polite"><span>Ürünler toplamı</span><strong>${money((window.TNMarketing?.cartSubtotal(cart) ?? cart.items.reduce((sum, item) => sum + Number(item.final_line_price || 0), 0)) - (cart.cart_level_discount_applications || []).reduce((sum, discount) => sum + Number(discount.total_allocated_amount || 0), 0))}</strong></div><p class="tn-cart-notice">Türkiye’de 1.200 TL ve üzeri siparişlerde standart kargo ücretsizdir. Hızlı kargo ücretlidir.</p>${window.TN.preview ? '<p class="tn-cart-notice">Yerel önizleme · Gerçek ödeme alınmaz.</p><button class="tn-button tn-full" data-preview-checkout>Ödeme adımını gör →</button>' : `<form action="${root}cart" method="post"><button class="tn-button tn-full" type="submit" name="checkout">Güvenli ödemeye geç →</button></form>`}<button class="tn-continue" data-continue-shopping>Alışverişe devam et</button></div>` : `<div class="tn-empty"><h2>Sepetiniz biraz<br>lezzet bekliyor.</h2><p>Sofranıza yakışacak bir şeyler bulalım.</p><a class="tn-button" href="${root}collections/zeytinyaglari">Zeytinyağlarını keşfet →</a></div>`;
    document.querySelectorAll('[data-cart-content],[data-cart-page]').forEach(el => {
      const previousScroll = el.querySelector('.tn-cart-lines')?.scrollTop || 0;
      el.innerHTML = html;
      const list = el.querySelector('.tn-cart-lines');
      if(list) list.scrollTop = previousScroll;
    });
    const error = document.querySelector('[data-cart-error]');
    if(error) error.textContent = '';
    if(focusControl) {
      const scope = dialog.open ? dialog : document.querySelector('[data-cart-page]');
      const buttons = [...(scope?.querySelectorAll('[data-cart-key]') || [])];
      const next = buttons.find(el => el.dataset.cartKey === focusControl.key && el.dataset.cartAction === focusControl.action && !el.disabled)
        || buttons.find(el => el.dataset.cartKey === focusControl.key && !el.disabled)
        || scope?.querySelector('button:not(:disabled),a');
      next?.focus({preventScroll:true});
    }
  }
  function openCart() {
    if(!dialog.open) dialog.showModal();
    document.documentElement.classList.add('tn-modal-open');
  }
  dialog.addEventListener('close', syncScrollLock);
  async function refresh() { const cart = await api('cart.js'); await paint(cart); return cart; }
  function report(error) { toast(error.message); const node = document.querySelector('[data-cart-error]'); if (node) node.textContent = error.message; }
  document.addEventListener('click', async e => {
    if (e.target.closest('[data-cart-open]')) { openCart(); if(!dialog.querySelector('[data-cart-content]').innerHTML) dialog.querySelector('[data-cart-content]').innerHTML = '<p class="tn-cart-content-loading" role="status">Sepetiniz yükleniyor…</p>'; try { await refresh(); } catch(error) { report(error); } }
    if (e.target.closest('[data-cart-close]')) dialog.close();
    if (e.target.closest('[data-continue-shopping]')) { if(dialog.open) dialog.close(); else location.assign(root+'collections/all'); }
    if (e.target === dialog) { const rect = dialog.getBoundingClientRect(); if (e.clientX < rect.left) dialog.close(); }
    const qty = e.target.closest('[data-qty]');
    if (qty) { const input = qty.parentElement.querySelector('input'); input.value = Math.max(1, Math.min(100, (parseInt(input.value) || 1) + Number(qty.dataset.qty))); }
    const change = e.target.closest('[data-cart-key]');
    if (change && !busy) {
      busy = true;
      const focusControl = {key:change.dataset.cartKey, action:change.dataset.cartAction};
      const scope = dialog.open ? dialog : document.querySelector('[data-cart-page]');
      const controls = [...scope.querySelectorAll('[data-cart-key]')];
      const enabled = controls.filter(el => !el.disabled);
      enabled.forEach(el => el.disabled = true);
      scope.setAttribute('aria-busy','true');
      try { await paint(await api('cart/change.js', {id:change.dataset.cartKey, quantity:Number(change.dataset.cartQuantity)}), focusControl); }
      catch(error) { report(error); }
      finally { busy = false; enabled.forEach(el => el.disabled = false); scope.removeAttribute('aria-busy'); }
    }
    if (e.target.closest('[data-preview-checkout]')) toast('Ödeme, Shopify mağazası bağlandıktan sonra etkinleşecek.');
    const tab = e.target.closest('[data-tab]');
    if (tab) activateTab(tab);
    const thumbnail = e.target.closest('[data-image]');
    if (thumbnail) {
      const mainImage = document.querySelector('[data-gallery-main] img');
      if (mainImage) {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = thumbnail.dataset.image;
        mainImage.alt = thumbnail.querySelector('img')?.alt || mainImage.alt;
      }
      thumbnail.parentElement.querySelectorAll('[data-image]').forEach(item => {
        item.classList.toggle('is-active', item === thumbnail);
        if (item === thumbnail) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
    }
    if (e.target.closest('[data-zoom]')) { const img = document.querySelector('[data-gallery-main] img'); if(img) { const zoom = document.querySelector('#tn-zoom-dialog'); zoom.querySelector('img').src = img.src; zoom.showModal(); } }
    if (e.target.closest('[data-zoom-close]')) document.querySelector('#tn-zoom-dialog').close();
  });
  function activateTab(tab) {
    document.querySelectorAll('[data-tab]').forEach(el => { el.setAttribute('aria-selected', String(el === tab)); el.tabIndex = el === tab ? 0 : -1; });
    document.querySelectorAll('[data-panel]').forEach(el => el.hidden = el.dataset.panel !== tab.dataset.tab);
  }
  document.querySelector('.tn-tabs')?.addEventListener('keydown', e => {
    if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
    e.preventDefault(); const tabs = [...document.querySelectorAll('[data-tab]')]; let index = tabs.indexOf(document.activeElement);
    index = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length-1 : (index + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    activateTab(tabs[index]); tabs[index].focus();
  });
  const openReviewTab = () => {
    const reviewTab = document.querySelector('#tab-reviews');
    if (location.hash === '#tab-reviews' && reviewTab) { activateTab(reviewTab); reviewTab.scrollIntoView({block:'start'}); }
  };
  openReviewTab();
  window.addEventListener('hashchange', openReviewTab);
  const variantPicker = document.querySelector('[data-variant]');
  const updateVariant = (selected, updateUrl = true) => {
    if (!selected) return;
    document.querySelectorAll('[data-product-price],[data-mobile-price]').forEach(el => el.textContent = selected.dataset.price);
    const unit = document.querySelector('[data-product-unit-price]');
    if (unit) { unit.textContent = selected.dataset.unitPrice || ''; unit.className = 'tn-unit-price'; }
    const compare = document.querySelector('[data-product-compare-price]');
    if (compare) { compare.hidden = !selected.dataset.comparePrice; compare.querySelector('s').textContent = selected.dataset.comparePrice || ''; }
    const sellable = selected.dataset.sellable === 'true';
    document.querySelectorAll('[data-product-submit]').forEach(el => el.disabled = !sellable);
    document.querySelectorAll('[data-add-label]').forEach(el => el.textContent = sellable ? 'Sepete ekle' : 'Stokta yok');
    const stock = document.querySelector('[data-product-stock]');
    if (stock) stock.textContent = sellable ? '● Stokta · Gönderime hazır' : 'Bu seçenek şu anda stokta yok';
    const sku = document.querySelector('[data-product-sku]');
    if (sku) sku.textContent = selected.dataset.sku || '';
    const skuRow = document.querySelector('[data-product-sku-row]');
    if (skuRow) skuRow.hidden = !selected.dataset.sku;
    if (updateUrl) {
      const url = new URL(location.href); url.searchParams.set('variant', selected.value);
      history.replaceState(history.state, '', url);
    }
  };
  variantPicker?.addEventListener('change', e => {
    if (e.target.matches('[data-variant-option]')) updateVariant(e.target);
  });
  window.addEventListener('popstate', () => {
    const id = new URL(location.href).searchParams.get('variant');
    const choice = [...(variantPicker?.querySelectorAll('[data-variant-option]') || [])].find(el => el.value === id);
    if (choice) { choice.checked = true; updateVariant(choice, false); }
  });
  document.querySelector('[data-sort-form] select')?.addEventListener('change', e => e.target.form.requestSubmit());
  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-add-form]');
    if (!form) return;
    e.preventDefault(); if (busy) return; const data = new FormData(form); const button = e.submitter; const quantity = Number(data.get('quantity') || 1);
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 100) return toast('Lütfen 1 ile 100 arasında bir adet seçin.');
    busy = true; if(button) button.disabled = true;
    const items = form.matches('[data-table-form]') ? data.getAll('table_variant').map(id => ({id, quantity:1})) : [{id:data.get('id'), quantity}];
    if (!items.length) { busy = false; if(button) button.disabled = false; return toast('Lütfen en az bir ürün seçin.'); }
    try { await api('cart/add.js', {items}); await refresh(); document.dispatchEvent(new Event('tn:cart-added')); if (button?.name === 'buy_now' && !window.TN.preview) location.assign(root+'checkout'); else { openCart(); if(button?.name === 'buy_now') toast('Ürün sepete eklendi. Ödeme Shopify bağlantısıyla açılacak.'); } }
    catch(error) { report(error); } finally { busy = false; if(button) button.disabled = false; }
  });
  const mobileBuy = document.querySelector('.tn-mobile-buy');
  document.querySelectorAll('[data-table-form]').forEach(form => {
    const update = () => {
      const chosen = [...form.querySelectorAll('input[name="table_variant"]:checked')];
      form.querySelector('[data-table-count]').textContent = `${chosen.length} ürün · Toplam`;
      form.querySelector('[data-table-total]').textContent = money(chosen.reduce((sum,item) => sum + Number(item.dataset.price),0));
      form.querySelector('button[type="submit"]').disabled = chosen.length === 0;
    };
    form.addEventListener('change', update);
    update();
  });
  const purchase = document.querySelector('.tn-purchase');
  if(mobileBuy && purchase) {
    const observer = new IntersectionObserver(entries => { mobileBuy.hidden = entries[0].isIntersecting; }, {threshold:0});
    observer.observe(purchase);
  }
  refresh().catch(error => { if(document.querySelector('[data-cart-page]')) report(error); });
})();

// Process showcase: three cards per desktop view, touch-friendly scroll snap on smaller screens.
document.querySelectorAll('[data-process-slider]').forEach(slider => {
  const track = slider.querySelector('[data-process-track]');
  const cards = [...track.querySelectorAll('.tn-process-card')];
  const current = slider.querySelector('[data-process-page]');
  const total = slider.querySelector('[data-process-pages]');
  const pageSize = () => matchMedia('(max-width: 760px)').matches ? 1 : matchMedia('(max-width: 1100px)').matches ? 2 : 3;
  const pages = () => Math.max(1, Math.ceil(cards.length / pageSize()));
  const update = () => { const page = Math.min(pages(), Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) + 1); current.textContent = page; total.textContent = pages(); };
  const move = direction => track.scrollBy({left: direction * track.clientWidth, behavior: 'smooth'});
  slider.querySelector('[data-process-prev]')?.addEventListener('click', () => move(-1));
  slider.querySelector('[data-process-next]')?.addEventListener('click', () => move(1));
  track.addEventListener('scroll', update, {passive:true});
  addEventListener('resize', update);
  update();
});

// Manual carousel: no timed movement; controls remain keyboard accessible.
(() => {
 const root=document.querySelector('.tn-banner-slider');if(!root)return;
 const slides=[...root.querySelectorAll('[data-hero-slide]')];
 const dots=[...root.querySelectorAll('[data-slide]')];let current=0;
 const show=index=>{current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>slide.hidden=i!==current);dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===current)));root.querySelector('[data-slide-status]').textContent=`${current+1} / ${slides.length}`;};
 dots.forEach((dot,i)=>dot.addEventListener('click',()=>show(i)));
 root.querySelector('[data-slide-prev]').addEventListener('click',()=>show(current-1));
 root.querySelector('[data-slide-next]').addEventListener('click',()=>show(current+1));
 root.querySelector('.tn-banner-controls').addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();show(current+(event.key==='ArrowRight'?1:-1));dots[current].focus();}});
})();

// Editable homepage campaign countdown. The ISO end time is configured in the theme editor.
document.querySelectorAll('[data-countdown]').forEach(section => {
  const deadline = new Date(section.dataset.countdownEnd).getTime();
  const fields = {
    days: section.querySelector('[data-countdown-days]'),
    hours: section.querySelector('[data-countdown-hours]'),
    minutes: section.querySelector('[data-countdown-minutes]')
  };
  if (!Number.isFinite(deadline)) { section.hidden = !window.Shopify?.designMode; return; }
  let timer;
  const render = () => {
    const remaining = Math.max(0, deadline - Date.now());
    const days = Math.floor(remaining / 86400000);
    const hours = Math.floor((remaining % 86400000) / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    fields.days.textContent = String(days).padStart(2, '0');
    fields.hours.textContent = String(hours).padStart(2, '0');
    fields.minutes.textContent = String(minutes).padStart(2, '0');
    if (remaining === 0) { section.hidden = !window.Shopify?.designMode; clearInterval(timer); }
  };
  render();
  if (deadline > Date.now()) timer = setInterval(render, 30000);
});

// Product assurance rotator. A fresh visit starts from a random message,
// while every claim remains tied to an actual store service.
document.querySelectorAll('[data-product-pulse]').forEach(pulse => {
  const messages = [...pulse.querySelectorAll('[data-product-pulse-message]')];
  if (!messages.length) return;
  let current = Math.floor(Math.random() * messages.length);
  const show = index => {
    current = (index + messages.length) % messages.length;
    messages.forEach((message, messageIndex) => {
      const active = messageIndex === current;
      message.classList.toggle('is-active', active);
      message.setAttribute('aria-hidden', String(!active));
    });
  };
  show(current);
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
    setInterval(() => show(current + 1), 4200);
  }
});
